// extracted by mini-css-extract-plugin
export default {"anim":"DivAnimate_anim__uuOH8","myDiv":"DivAnimate_myDiv__p-r-O"};